// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.G7WszObTDQMXsQ {
  display: inline-flex;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  padding: 6px 12px;
  border-radius: var(--ds-border-radius-100, 3px);
  text-decoration: none;
  white-space: normal;
  cursor: pointer;
  background-color: var(--ds-background-neutral, #091e420f);
  color: var(--ds-text, #172b4d);
  font-weight: var(--ds-font-weight-medium, 500);
  transition-property: background-color, border-color, box-shadow;
  transition-duration: 85ms;
  transition-timing-function: ease;
  border: none;
  background-color: transparent;
  box-shadow: none;
  flex-grow: 0;
  flex-shrink: 0;
  margin-bottom: var(--ds-space-0, 0px);
  padding: var(--ds-space-100, 8px);
  border-radius: var(--ds-border-radius-200, 8px);
  color: var(--accent-text, var(--ds-icon-subtle, #626f86));
}
.G7WszObTDQMXsQ:hover {
  background-color: var(--accent-background-hovered, var(--ds-background-neutral-hovered, #091e4224));
  color: var(--accent-text-bolder, var(--ds-icon, #44546f));
}
.G7WszObTDQMXsQ:active {
  background-color: var(--accent-background-pressed, var(--ds-background-neutral-pressed, #091e424f));
  color: var(--accent-text-bolder, var(--ds-icon, #44546f));
}
@media print {
  .G7WszObTDQMXsQ {
    display: none;
  }
}
.VWWuT0xpE9CBME {
  display: inline-flex;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  padding: 6px 12px;
  border-radius: var(--ds-border-radius-100, 3px);
  text-decoration: none;
  white-space: normal;
  cursor: pointer;
  background-color: var(--ds-background-neutral, #091e420f);
  color: var(--ds-text, #172b4d);
  font-weight: var(--ds-font-weight-medium, 500);
  border: none;
  background-color: transparent;
  box-shadow: none;
  flex-grow: 0;
  flex-shrink: 0;
  margin-bottom: var(--ds-space-0, 0px);
  padding: var(--ds-space-100, 8px);
  border-radius: var(--ds-border-radius-200, 8px);
  color: var(--accent-text, var(--ds-icon-subtle, #626f86));
  order: 0;
}
.VWWuT0xpE9CBME:hover {
  background-color: var(--accent-background-hovered, var(--ds-background-neutral-hovered, #091e4224));
  color: var(--accent-text-bolder, var(--ds-icon, #44546f));
}
.VWWuT0xpE9CBME:active {
  background-color: var(--accent-background-pressed, var(--ds-background-neutral-pressed, #091e424f));
  color: var(--accent-text-bolder, var(--ds-icon, #44546f));
}
@media print {
  .VWWuT0xpE9CBME {
    display: none;
  }
}
:hover > .VWWuT0xpE9CBME,
:active > .VWWuT0xpE9CBME {
  background-color: transparent;
  color: var(--accent-text-bolder, var(--ds-icon, #44546f));
}
`, ""]);
// Exports
export var collapseListButton = `G7WszObTDQMXsQ`;
export var expandListButton = `VWWuT0xpE9CBME`;
export default ___CSS_LOADER_EXPORT___;
